import { render, staticRenderFns } from "./NestedActivityContent.vue?vue&type=template&id=2d8a287e"
import script from "./NestedActivityContent.vue?vue&type=script&lang=js"
export * from "./NestedActivityContent.vue?vue&type=script&lang=js"
import style0 from "./NestedActivityContent.vue?vue&type=style&index=0&id=2d8a287e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports